<template>
    <div>
        <div v-if="curShowPage=='list'">
            <div class="filter-bar mb10">
                <el-form :inline="true" @submit.native.prevent="submitSearch">
                    <el-form-item label="">
                        <el-input v-model="tempQuery.task_search" @keyup.enter.native="submitSearch" @clear="submitSearch" clearable placeholder="Enter Task Name or Task ID to Search" style="width: 260px;">
                            <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select
                            class="select-tags-width"
                            v-model="tempQuery.account_id"
                            placeholder="Account Filter, Supports Name or ID Search"
                            multiple
                            collapse-tags
                            clearable
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="(query) => remoteMethod(query, 'creator')"
                            :loading="searchAccountLoading"
                                   style="width: 220px">
                            <el-option v-for="item in filterAccountOptions" :key="item.id"
                                       :label="item.name + '(' + item.id + ')'" :value="item.id">
                                <span style="float: left">{{ item.name }}（{{ item.id }}）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select
                            class="select-tags-width"
                            v-model="tempQuery.subitem_id"
                            placeholder="Product Filter, Supports Name, ID, or Package Name Search"
                            style="width: 220px"
                            multiple
                            collapse-tags
                            clearable
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="(query) => remoteMethod(query, 'app')"
                            :loading="searchAppLoading"
                        >
                            <el-option v-for="item in filterAppOptions" :key="item.subitem_id"
                                       :label="item.subproject_name + '(' + item.subproject_id + ')'" :value="item.subitem_id">
                                <span style="float: left">{{ item.subproject_name }}（{{ item.subproject_id }}）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="tempQuery.template_id" placeholder="Template Filter" style="width: 175px"
                                   class="select-tags-width" multiple collapse-tags clearable filterable>
                            <el-option :label="option.template_name" :value="option.template_id"
                                       v-for="option in filterTempOptions" :key="option.template_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="tempQuery.send_status" placeholder="Send Status" style="width: 165px" class="select-tags-width" multiple collapse-tags clearable filterable>
                            <el-option label="Not Sent" value="0"></el-option>
                            <el-option label="Sent" value="1"></el-option>
                            <el-option label="Sending" value="2"></el-option>
                            <el-option label="Send Failed" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="tempQuery.status" placeholder="Scheduled Generation Status" style="width: 140px" class="select-tags-width" multiple collapse-tags clearable filterable>
                            <el-option label="Run" value="1"></el-option>
                            <el-option label="Pause" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="tempQuery.auto_send" placeholder="Auto Send Status" style="width: 140px" class="select-tags-width" multiple collapse-tags clearable filterable>
                            <el-option label="Run" value="1"></el-option>
                            <el-option label="Pause" value="0"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="">
                        <el-select v-model="tempQuery.user_ids" class="select-tags-width" multiple collapse-tags clearable filterable placeholder="Owner" style="width: 150px;">
                            <el-option v-for="item in userList" :label="item.creator" :value="item.uid" :key="item.uid">
                                {{item.creator}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="tempQuery.group_id" class="select-tags-width" multiple collapse-tags clearable filterable placeholder="Owner's Department" style="width: 175px;">
                            <el-option v-for="item in groupList" :label="item.name" :value="item.id" :key="item.id">
                                {{item.name}}
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="">
                        <el-button size="mini" type="primary" :loading="dataLoading" @click="submitSearch" style="width: 75px;">Filter</el-button>
                        <el-button size="mini" @click="resetForm">Reset Filters</el-button>
                    </el-form-item>

                </el-form>
            </div>
            <div class="table-tool-bar clearfix mb10">
                <div class="fl">
                    <el-button type="primary" v-if="pageFuncNames.includes('daily_task_feature')" @click="showCreatePage"  size="mini" class="mr10">Create Task</el-button>
                    <el-popconfirm
                        :disabled="rowSelected.length<=0"
                        v-if="pageFuncNames.includes('daily_task_button')"
                        :title="'Batch Generate Reports: Yes/No?'"
                        @confirm="batchGen"
                    >
                        <el-button slot="reference" type="primary" :disabled="rowSelected.length<=0" :loading="batchGenLoading" plain size="mini" class="mr10">Batch Generate</el-button>
                    </el-popconfirm>
                    <el-popconfirm
                        :disabled="rowSelected.length<=0"
                        v-if="pageFuncNames.includes('daily_task_button')"
                        :title="'Batch Send Reports: Yes/No?'"
                        @confirm="batchSend"
                    >
                        <el-button slot="reference" type="success" :disabled="rowSelected.length<=0" :loading="batchSendLoading" plain size="mini" class="mr10">Batch Send</el-button>
                    </el-popconfirm>

                    <!--<el-button type="primary" v-if="pageFuncNames.includes('daily_task_button')" @click="batchGen" :disabled="rowSelected.length<=0" :loading="batchGenLoading" plain size="mini" class="mr10">批量生成</el-button>-->
                    <!--<el-button type="success" v-if="pageFuncNames.includes('daily_task_button')" @click="batchSend" :disabled="rowSelected.length<=0" :loading="batchSendLoading" plain size="mini" class="mr10">批量发送</el-button>-->
                </div>
            </div>
            <div class="data-list">
                <el-table
                    key="task-table"
                    ref="dataTable"
                    :data="dataList"
                    v-loading="dataLoading"
                    @selection-change="rowSelectionChange"
                    tooltip-effect="dark"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    stripe
                    style="width: 100%;">
                    <el-table-column
                        fixed
                        type="selection"
                        align="center"
                        width="60">
                    </el-table-column>
                    <el-table-column
                        prop="task_number"
                        label="Task ID"
                        align="center"
                        width="80">
                    </el-table-column>
                    <el-table-column
                        prop="task_name"
                        show-overflow-tooltip
                        label="Task Name"
                        align="center"
                        min-width="200">
                        <template slot-scope="scope">
                            <span class="text-color-primary pointer" @click="toDetailPage(scope.row)">{{scope.row.task_name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="Scheduled Generation Toggle"
                        align="center"
                        min-width="120">
                        <template slot-scope="scope">
                            <el-switch
                                v-if="pageFuncNames.includes('daily_task_feature')"
                                class="mini-switch"
                                :value="scope.row.status"
                                :disabled="scope.row.statusLoading"
                                @change="changeTaskStatus(scope.row,$event)"
                                active-value="1"
                                inactive-value="0"
                            ></el-switch>
                            <span v-else>{{scope.row.status=='1'?'开':scope.row.status=='0'?'关':'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="auto_send"
                        label="Auto Send"
                        align="center"
                        min-width="120">
                        <template slot="header" slot-scope="scope">
                            Auto Send
                            <el-tooltip class="item" effect="dark" placement="top">
                                <i class="el-icon-question pointer"></i>
                                <div slot="content" style="max-width: 300px;">
                                    <p style="line-height: 1.5;" class="mb10">When on, the automated report will be sent automatically to the configured recipients after generation.
                                        This requires coordination with scheduled generation. Manually generated automated reports will not be sent automatically and require manual sending.</p>
                                </div>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            <el-switch
                                v-if="pageFuncNames.includes('daily_task_autosend')"
                                class="mini-switch"
                                :value="scope.row.auto_send"
                                :disabled="scope.row.autoSendLoading"
                                @change="changeAutoSend(scope.row,$event)"
                                active-value="1"
                                inactive-value="0"
                            ></el-switch>
                            <span v-else>{{scope.row.auto_send=='1'?'Run':scope.row.auto_send=='0'?'Pause':'--'}}</span>
                        </template>
                    </el-table-column>
                    <!--<el-table-column-->
                        <!--prop="task_num"-->
                        <!--label="文件数"-->
                        <!--align="center"-->
                        <!--min-width="100">-->
                        <!--<template slot-scope="scope">-->
                            <!--<span>{{scope.row.task_num.normal_num}} / {{scope.row.task_num.total_num}}</span>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column
                        prop="last_generate_status"
                        label="Last Generation Status"
                        align="center"
                        min-width="180">
                        <template slot-scope="scope">
                           <p>
                               <span class="mr10">Success(<span class="text-color-success">{{scope.row.last_generate_status.success}}</span>)</span>
                               <span>Failure(<span class="text-color-error">{{scope.row.last_generate_status.fail}}</span>)</span>
                           </p>
                            <p>
                                <span class="mr10">In Progress(<span>{{scope.row.last_generate_status.inProgress}}</span>)</span>
                                <span>Not Started(<span>{{scope.row.last_generate_status.unExecuted}}</span>)</span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="last_generate_time"
                        label="Last Generation Time"
                        align="center"
                        width="100">
                        <template slot-scope="scope">
                            <p style="max-width: 70px;">{{scope.row.last_generate_time}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="total_time"
                        label="Generation Duration"
                        align="center"
                        min-width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.total_time==='0'||scope.row.total_time===0">0s</span>
                            <span v-else-if="!scope.row.total_time">--</span>
                            <span v-else>{{secondToDuration(scope.row.total_time)||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="last_send_status"
                        label="Send Status"
                        align="center"
                        min-width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.last_send_status == '1'" class="text-color-success">Sent</span>
                            <span v-else-if="scope.row.last_send_status == '2'" class="text-color-warn">Sending</span>
                            <div v-else-if="scope.row.last_send_status == '3'" class="pointer">
                                <el-tooltip class="item" effect="dark" placement="top">
                                    <span class="mr4 text-color-failed">Send Failed
                                        <i class="el-icon-warning-outline text-color-failed"></i>
                                    </span>
                                    <div slot="content" style="max-width: 500px;max-height: 300px;overflow-y: auto;" class="break-word">
                                        <div v-if="scope.row.send_error_info" v-html="scope.row.send_error_info"></div>
                                        <span v-else>Send Failed</span>
                                    </div>
                                </el-tooltip>
                            </div>
                            <span v-else>Not Sent</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="last_send_time"
                        label="Send Time"
                        align="center"
                        width="100">
                        <template slot-scope="scope">
                            <p style="max-width: 70px;">{{scope.row.last_send_time}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="generate_time_format"
                        label="Scheduled Generation Time"
                        align="center"
                        min-width="250">
                        <template slot-scope="scope">
                            <p>{{scope.row.generate_frequency_format}}</p>
                            <p>{{scope.row.generate_time_format}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="body"
                        label="Email Information"
                        align="center"
                        min-width="100">
                        <template slot-scope="scope">
                            <span class="text-color-primary pointer" @click="viewMailInfo(scope.row)">View</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="creator"
                        label="Owner"
                        align="center"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        prop="ctime"
                        label="Creation Date"
                        align="center"
                        min-width="90">
                        <template slot-scope="scope">
                            <p style="max-width: 70px;">{{scope.row.ctime}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        prop="action"
                        label="Actions"
                        align="center"
                        min-width="190">
                        <template slot-scope="scope">
                            <template v-if="pageFuncNames.includes('daily_task_button')">
                                <el-popconfirm
                                    v-if="scope.row.last_generate_status.inProgress<=0"
                                    :title="'Generate Report: Yes/No：'+scope.row.task_name+'?'"
                                    @confirm="genTask(scope.row)"
                                >
                                    <span class="text-color-primary pointer mr10" slot="reference">Generate</span>
                                </el-popconfirm>
                                <span v-else class="text-color-primary pointer mr10 disabled" @click="genTask(scope.row)" title="This task is currently generating, please try again later" slot="reference">Generate</span>
                            </template>
                            <el-button class="text-success mr10" :disabled="scope.row.sendLoading" type="text" v-if="pageFuncNames.includes('daily_task_button')" @click="sendTask(scope.row)">Send</el-button>
                            <!--<el-button class="topBtn mr10" type="text" v-if="scope.row.is_top!='1'"   size="small"  :loading="scope.row.topLoading"  @click="setTaskTop(scope.row)">置顶</el-button>-->
                            <!--<el-button class="topBtn mr10" type="text" v-else    size="small"  :loading="scope.row.topLoading"  @click="setTaskTop(scope.row)">取消置顶</el-button>-->

                            <span :class="[scope.row.topLoading?'disabled':'']" class="topBtn font12px text-bold pointer mr10 icon iconfont icon-jt-zhiding" v-if="scope.row.is_top!='1'" @click="setTaskTop(scope.row)" title="Pin to top "></span>
                            <span :class="[scope.row.topLoading?'disabled':'']" class="topBtn font12px text-bold pointer mr10 icon iconfont icon-jt-zhiding text-color-primary" v-else @click="setTaskTop(scope.row)" title="Unpin"></span>

                            <el-dropdown @command="handleCommand(scope.row,$event)">
                                <span class="el-dropdown-link pointer">More<i class="el-icon-arrow-down el-icon--right"></i></span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="edit" v-if="pageFuncNames.includes('daily_task_feature')" :disabled="scope.row.last_generate_status.inProgress!='0'" :title="scope.row.last_generate_status.inProgress!='0'?'Reports in progress cannot be edited':''">Edit</el-dropdown-item>
                                    <el-dropdown-item command="record">Generation Records</el-dropdown-item>
                                    <!--<el-dropdown-item command="position">调整位置</el-dropdown-item>-->
                                    <el-dropdown-item command="delete"
                                                      v-if="pageFuncNames.includes('daily_task_feature')"
                                                      :disabled="scope.row.last_generate_status.inProgress!='0'"
                                                      :title="scope.row.last_generate_status.inProgress!='0'?'Reports in progress cannot be deleted':''"
                                    ><span :class="[scope.row.last_generate_status.inProgress!='0'?'':'text-color-error']">Delete</span></el-dropdown-item>
                                </el-dropdown-menu>

                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="page-bar tac mt20">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryData.pn"
                    :page-sizes="[30,50,100]"
                    :page-size="queryData.rn"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>
            </div>

            <MailInfoModal ref="mailInfoModal" :data="actionRow" :type="actionType" @update="getDataList" />
            <ErrTipModal ref="errTipModal" @ok="confirmErrTip"/>
        </div>
        <div v-else-if="curShowPage=='create'">
            <CreatePage ref="createPage" :allowed-plat-list="allowedPlatList" :data="actionRow" :page-func-names="pageFuncNames" :type="actionType" @back="showListPage" @update="getDataList"/>
        </div>
        <div v-else-if="curShowPage=='detail'">
            <DetailPage ref="detailPage" :data="actionRow" :page-func-names="pageFuncNames" @back="showListPage" @update="getDataList" @edit="editTask"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import CreatePage from './create';
    import DetailPage from './detailList';
    import MailInfoModal from './modal/mailInfoModal';
    import API from '@/api/efficiencyToolEn/task.js';
    import utils from '@/libs/utils.js';
    import ErrTipModal from '../../modal/errorTipModal';

    export default {
        name: "TaskList",
        components:{
            CreatePage,
            DetailPage,
            MailInfoModal,
            ErrTipModal,
        },
        props:{
            allowedPlatList:Array,
            pageFuncNames:Array,
        },
        data(){
            return {
                curShowPage:'list',
                dataLoading:false,
                queryData:{
                    task_search:'',
                    user_ids:[],
                    group_id:[],
                    account_id:[],
                    subitem_id:[],
                    template_id:[],
                    send_status:[],
                    status:[],
                    auto_send:[],
                    pn: 1,
                    rn: 30,
                },
                tempQuery:{
                    task_search:'',
                    user_ids:[],
                    group_id:[],
                    account_id:[],
                    subitem_id:[],
                    template_id:[],
                    send_status:[],
                    status:[],
                    auto_send:[],
                },
                userList:[],
                groupList:[],
                filterAccountOptions: [],
                filterAppOptions: [],
                filterTempOptions:[],
                searchAppLoading:false,
                searchAccountLoading:false,
                batchGenLoading:false,
                batchSendLoading:false,
                dataList:[],
                totalCnt:0,
                rowSelected:[],
                actionRow:{},
                actionType:'',
                refreshTimer:null,
            }
        },
        computed:{
            ...mapGetters(['name','user_id']),
        },
        mounted(){
            this.getSelectOptions();
            // this.submitSearch();
            this.startRefresh();
        },
        watch:{
            curShowPage(val){
                let isListPage = val==='list';
                if(isListPage){
                    console.log('startRefresh');
                    if(!this.refreshTimer){
                        this.startRefresh();
                    }
                }else {
                    console.log('stopRefresh');
                    this.stopRefresh();
                }
            },
        },
        methods:{
            searchList(data){
                if(this.curShowPage!='list'){
                    this.curShowPage = 'list';
                }
                this.resetForm(data);
                if(data.template_id){
                    this.tempQuery.template_id = [data.template_id];
                }
                if(data.search){
                    this.tempQuery.task_search = data.search;
                }

                this.submitSearch(data.detail);
            },
            getSelectOptions(){
                /* 获取归属人下拉列表 */
                API.getUserOptions().then(res=>{
                    this.userList = res.data||[];

                    let userData = this.userList.find(item=>item.uid==this.user_id&&item.creator==this.name);
                    if(!userData){
                        this.userList.push({
                            uid:this.user_id,
                            creator:this.name,
                        })
                    }
                    this.tempQuery.user_ids = [this.user_id];
                },err=>{
                    console.log('getUserOptions',err);
                    this.userList = [{
                        uid:this.user_id,
                        creator:this.name,
                    }];
                });

                /* 获取归属部门下拉列表 */
                API.getGroupOptions().then(res=>{
                    this.groupList = res.data||[];
                },err=>{
                    console.log('getGroupOptions',err);
                    this.groupList = [];
                });

                /* 获取模板下拉列表*/
                API.getSearchTemplateList().then(res=>{
                    this.filterTempOptions = res.data||[];
                },err=>{
                    console.log('getGroupOptions',err);
                    this.filterTempOptions = [];
                });
            },
            remoteMethod(query, type) {
                if (!query){
                    if (type == 'creator') {
                        return this.filterAccountOptions = [];
                    } else {
                        return this.filterAppOptions = [];
                    }
                }
                if(type === 'creator'){
                    this.searchAccountLoading = true;
                }else{
                    this.searchAppLoading = true;
                }

                API.getSearchOptions({
                    search_type: type,
                    search: query,
                    source:'task',      // task-任务页面,record-任务记录页面
                }).then(res => {
                    let result = res.data||[];
                    if (type == 'creator') {
                        this.filterAccountOptions = result;
                        this.searchAccountLoading = false;
                    } else {
                        this.filterAppOptions = result;
                        this.searchAppLoading = false;
                    }
                });
            },
            getDataList(isToDetail){
                console.log('getDataList');
                this.dataLoading = true;
                API.getTaskList({
                    task_search:this.queryData.task_search,
                    user_ids:this.queryData.user_ids,
                    group_id:this.queryData.group_id,
                    status:this.queryData.status,
                    auto_send:this.queryData.auto_send,
                    send_status:this.queryData.send_status,
                    template_id:this.queryData.template_id,
                    subitem_ids:this.queryData.subitem_id,
                    account_id:this.queryData.account_id,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    this.dataList = (resData.list || []).map(item=>{
                        item.genLoading = false;
                        item.sendLoading = false;
                        item.statusLoading = false;
                        item.autoSendLoading = false;
                        item.topLoading = false;
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;

                    if(isToDetail){
                        let searchText = this.$route.params.search||this.$route.query.search;
                        let actionRow = this.dataList.find(item=>item.task_number==searchText);
                        if(actionRow){
                            this.$nextTick(()=>{
                                this.toDetailPage(actionRow);
                            })
                        }else{
                            this.$message.error('Task Not Found');
                        }
                    }
                }, (err) => {
                    console.log('getTaskList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            resetForm(data){

                let userData = this.userList.find(item=>item.uid==this.user_id&&item.creator==this.name);
                if(userData&&!data.search){
                    this.tempQuery.user_ids = [userData.uid];
                }else{
                    this.tempQuery.user_ids = [this.user_id];
                }


                this.tempQuery.task_search = '';

                this.tempQuery.group_id = [];
                this.tempQuery.subitem_id = [];
                this.tempQuery.account_id = [];
                this.tempQuery.template_id = [];
                this.tempQuery.send_status = [];
                this.tempQuery.status = [];
                this.tempQuery.auto_send = [];
            },
            submitSearch(isToDetail){
                this.queryData.gr = 1;
                this.queryData.task_search = this.tempQuery.task_search;
                this.queryData.user_ids = this.tempQuery.user_ids;
                this.queryData.group_id = this.tempQuery.group_id;
                this.queryData.template_id = this.tempQuery.template_id;
                this.queryData.send_status = this.tempQuery.send_status;
                this.queryData.status = this.tempQuery.status;
                this.queryData.auto_send = this.tempQuery.auto_send;
                this.queryData.account_id = this.tempQuery.account_id;
                this.queryData.subitem_id = this.tempQuery.subitem_id;
                if(!this.isEvent(isToDetail)||isToDetail===true){
                    this.getDataList(isToDetail);
                }else{
                    this.getDataList();
                }
            },
            showCreatePage(){
                console.log('showCreatePage');
                this.actionType = 'add';
                this.actionRow = {};
                this.curShowPage = 'create';
            },
            batchGen(){
                if(this.rowSelected.length<=0) return false;
                let taskIds = this.rowSelected.map(item=>item.task_id);
                this.batchGenLoading = true;

                API.checkTaskPerm({
                    task_id:taskIds.join(','),
                }).then(()=>{
                    API.genTask({
                        task_id:taskIds.join(','),
                    }).then(res=>{
                        this.batchGenLoading = false;
                        let resData = res.data||{};
                        let errList = resData.error||[];
                        if(errList.length<=0){
                            this.$message.success(res.info||'Task created successfully, generating');
                        }else{
                            this.$notify.error({
                                title: 'Some reports failed to generation:',
                                dangerouslyUseHTMLString: true,
                                message: '<div style="max-height: 200px;overflow-y: auto;" class="pr10">'+errList.map(item=>`<p class="font12px" style="margin-bottom: 6px;">${item}</p>`).join('')+'</div>',
                                duration: 0
                            });
                        }
                        this.getDataList();
                    },err=>{
                        console.log('batchGen err',err);
                        this.batchGenLoading = false;
                        let errData = err.data||[];
                        if(err.code==0&&errData.length>0){
                            this.$notify.error({
                                title: err.info||'Some reports failed to generation:',
                                message: errData.map(item=>item).join('；'),
                                duration: 0
                            });
                        }else{
                            this.$message.error(err.info||'Request Error');
                        }
                    });
                },err=>{
                    this.batchGenLoading = false;
                    console.log('batch checkTaskPerm err',err);
                    if(err.code==403){
                        return this.$message.error(err.info||'Request Error');
                    }
                    let errData = err.data||{};
                    let errList = errData.error_auth||[];
                    this.$refs.errTipModal.showModal({
                        title:err.info||'The following accounts do not have permission and cannot generate this file, do you want to continue generating?',
                        subTitle:'Continuing will turn off the status of files without permission and continue generating other files',
                        actionType:'batchGenTask',
                        errList:errList,
                        actionData:taskIds.join(','),
                        isConfirm:true,
                    });
                });

            },
            batchSend(){
                if(this.rowSelected.length<=0) return false;
                let taskIds = this.rowSelected.map(item=>item.task_id);
                this.batchSendLoading = true;
                API.batchSendTask({
                    task_id:taskIds.join(','),
                }).then(res=>{
                    this.batchSendLoading = false;
                    // this.$message.success(res.info||'请求成功');
                    let resData = res.data||{};
                    let errList = resData.error||[];
                    if(errList.length<=0){
                        this.$message.success(res.info||'任务创建成功，正在发送');
                    }else{
                        this.$notify.error({
                            title: 'Some reports failed to send:',
                            dangerouslyUseHTMLString: true,
                            message: '<div style="max-height: 200px;overflow-y: auto;" class="pr10">'+errList.map(item=>`<p class="font12px" style="margin-bottom: 6px;">${item}</p>`).join('')+'</div>',
                            duration: 0
                        });
                    }
                    this.getDataList();
                },err=>{
                    console.log('batchGen err',err);
                    this.batchSendLoading = false;
                    let errData = err.data;

                    if(Array.isArray(errData)){
                        if(err.code==0&&errData.length>0){
                            this.$notify.error({
                                title: err.info||'The following reports failed to send:',
                                message: errData.map(item=>item).join('；'),
                                duration: 0
                            });
                        }else{
                            this.$message.error(err.info||'Request Error');
                        }
                    }else{
                        if(err.code==403){
                            return this.$message.error(err.info||'Request Error');
                        }
                        let errList = (errData||{}).error_auth||[];
                        this.$refs.errTipModal.showModal({
                            title:err.info||'The following accounts do not have permission and cannot be operated',
                            subTitle:'You can confirm the permissions and resend, if you can ignore the files without permission, regenerate and send again',
                            actionType:'batchSendTask',
                            isConfirm:false,
                            errList:errList,
                            actionData:'',
                        });
                    }

                });
            },
            rowSelectionChange(val){
                this.rowSelected = val.map(item => item);
            },
            handleSizeChange(val) {
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            showListPage(){
                this.curShowPage = 'list';
            },
            viewMailInfo(row){
                console.log('viewMailInfo',row);
                this.actionRow = {...row};
                this.actionType = 'view';
                this.$nextTick(()=>{
                    this.$refs.mailInfoModal.showModal();
                });
            },
            genTask(row){
                if(row.genLoading) return console.log('loading');
                if(row.last_generate_status.inProgress>0) return this.$message.warning('This task is currently generating, please try again later');
                row.genLoading = true;

                API.checkTaskPerm({
                    task_id:row.task_id,
                }).then(()=>{
                    API.genTask({
                        task_id:row.task_id,
                    }).then(res=>{
                        console.log('genTask',res);
                        row.genLoading = false;

                        let resData = res.data||{};
                        let errList = resData.error||[];
                        if(errList.length<=0){
                            this.$message.success(res.info||'Task created successfully, generating');
                        }else{
                            this.$notify.error({
                                title: 'Some reports failed to generation:',
                                dangerouslyUseHTMLString: true,
                                message: '<div style="max-height: 200px;overflow-y: auto;" class="pr10">'+errList.map(item=>`<p class="font12px mb6">${item}</p>`).join('')+'</div>',
                                duration: 0
                            });
                        }
                        this.getDataList();
                    },err=>{
                        console.log('genTask err',err);
                        row.genLoading = false;
                        this.$message.error(err.info||'Request Error');
                    })
                },err=>{
                    row.genLoading = false;
                    console.log('checkTaskPerm err',err);
                    if(err.code==403){
                        return this.$message.error(err.info||'Request Error');
                    }
                    let errData = err.data||{};
                    let errList = errData.error_auth||[];
                    this.$refs.errTipModal.showModal({
                        title:err.info||'The following accounts do not have permission and cannot generate this file, do you want to continue generating?',
                        subTitle:'Continuing will turn off the status of files without permission and continue generating other files',
                        actionType:'genTask',
                        isConfirm:true,
                        errList:errList,
                        actionData:row,
                    });
                });
            },
            confirmErrTip(type,data){
                if(type=='genTask'){
                    let actionData = this.dataList.find(item=>item.task_id == data.task_id);
                    API.genTask({
                        task_id:data.task_id,
                    }).then(res=>{
                        console.log('genTask',res);
                        this.$refs.errTipModal.setOkLoading(false);
                        actionData.genLoading = false;

                        let resData = res.data||{};
                        let errList = resData.error||[];
                        if(errList.length<=0){
                            this.$message.success(res.info||'Task created successfully, generating');
                        }else{
                            this.$notify.error({
                                title: 'Some reports failed to generation:',
                                dangerouslyUseHTMLString: true,
                                message: '<div style="max-height: 200px;overflow-y: auto;" class="pr10">'+errList.map(item=>`<p class="font12px mb6">${item}</p>`).join('')+'</div>',
                                duration: 0
                            });
                        }
                        this.getDataList();
                        this.$refs.errTipModal.hideModal();
                    },err=>{
                        console.log('genTask err',err);
                        actionData.genLoading = false;
                        this.$refs.errTipModal.setOkLoading(false);
                        this.$message.error(err.info||'Request Error');
                    })
                }else if(type=='batchGenTask'){
                    this.batchGenLoading = true;
                    API.genTask({
                        task_id:data,
                    }).then(res=>{
                        this.$refs.errTipModal.setOkLoading(false);
                        this.batchGenLoading = false;
                        let resData = res.data||{};
                        let errList = resData.error||[];
                        if(errList.length<=0){
                            this.$message.success(res.info||'Task created successfully, generating');
                        }else{
                            this.$notify.error({
                                title: 'Some reports failed to generation:',
                                dangerouslyUseHTMLString: true,
                                message: '<div style="max-height: 200px;overflow-y: auto;" class="pr10">'+errList.map(item=>`<p class="font12px" style="margin-bottom: 6px;">${item}</p>`).join('')+'</div>',
                                duration: 0
                            });
                        }
                        this.getDataList();
                        this.$refs.errTipModal.hideModal();
                    },err=>{
                        console.log('batchGen err',err);
                        this.batchGenLoading = false;
                        this.$refs.errTipModal.setOkLoading(false);
                        let errData = err.data||[];
                        if(err.code==0&&errData.length>0){
                            this.$notify.error({
                                title: err.info||'Some reports failed to generation:',
                                message: errData.map(item=>item).join('；'),
                                duration: 0
                            });
                        }else{
                            this.$message.error(err.info||'Request Error');
                        }
                    });
                }
            },
            sendTask(row){
                console.log('sendTask',row);
                row.sendLoading = true;
                API.getTaskMailInfo({
                    task_id:row.task_id,
                }).then(()=>{
                    row.sendLoading = false;
                    this.actionRow = {...row};
                    this.actionType = 'send';
                    this.$refs.mailInfoModal.showModal();
                },err=>{
                    // this.$message.error(err.info||'Request Error');
                    row.sendLoading = false;

                    let errData = err.data||{};
                    if(Array.isArray(errData)){
                        if(err.code==0&&errData.length>0){
                            this.$notify.error({
                                title: err.info||'The following reports failed to send:',
                                message: errData.map(item=>item).join('；'),
                                duration: 0
                            });
                        }else{
                            this.$message.error(err.info||'Request Error');
                        }
                    }else{
                        if(err.code==403){
                            return this.$message.error(err.info||'Request Error');
                        }
                        let errList = (errData||{}).error_auth||[];
                        this.$refs.errTipModal.showModal({
                            title:err.info||'The following accounts do not have permission and cannot be sent',
                            subTitle:'You can confirm the permissions and resend, if you can ignore the files without permission, regenerate and send again',
                            actionType:'sendTask',
                            isConfirm:false,
                            errList:errList,
                            actionData:'',
                        });
                    }

                });
            },
            setTaskTop(row){
                if(row.topLoading) return false;
                let taskId = row.task_id;
                let curTopStatus = row.is_top;
                row.topLoading = true;
                API.setTaskTop({
                    task_id:taskId,
                    is_top:curTopStatus=='1'?'0':'1'
                }).then(res=>{
                    row.topLoading = false;
                    this.$message.success(res.info||'Modified successfully');
                    this.getDataList();
                },err=>{
                    console.log('setTaskTop err',err);
                    row.topLoading = false;
                    this.$message.error(err.info||'Modification failed');
                });
            },
            handleCommand(data,val){
                console.log('handleCommand',data,val);
                switch (val) {
                    case 'edit':
                        this.actionType = 'edit';
                        this.actionRow = {...data};
                        this.curShowPage = 'create';
                        this.$nextTick(()=>{
                            this.$refs.createPage.setData();
                        });
                        break;
                    case 'record':
                        this.toRecordPage({...data});
                        break;
                    case 'position':
                        // this.actionRow = {...data};
                        // this.$refs.posModal.showModal();
                        break;
                    case 'delete':
                        this.$alert('Are you sure you want to delete the task：<span class="text-bold">'+data.task_name+'</span> ?', {
                            type:'error',
                            confirmButtonText:'Confirm Delete',
                            confirmButtonClass:'danger-button',
                            showCancelButton:true,
                            dangerouslyUseHTMLString:true,
                        }).then(()=>{
                            API.deleteTask({
                                task_id:data.task_id,
                            }).then(res=>{
                                this.$message.success(res.info||'Operation successful');
                                this.getDataList();
                            },err=>{
                                console.log('deleteTask err',err);
                                this.$message.error(err.info||'Request Error');
                            })
                        }).catch(()=>{
                            console.log('取消删除');
                        });
                        break;
                }
            },
            toRecordPage(row){
                console.log('toRecordPage',row);
                this.$emit('toRecordPage',row);
            },
            changeTaskStatus(row,val){
                console.log('changeTaskStatus',row,val);
                row.statusLoading = true;
                API.changeTaskStatus({
                    task_id:row.task_id,
                    status:val,
                }).then(res=>{
                    row.statusLoading = false;
                    row.status = val;
                    this.$message.success(res.info||'Operation successful');
                },err=>{
                    row.statusLoading = false;

                    let errData = err.data||[];
                    if(err.code==0&&errData.length>0){
                        this.$notify.error({
                            title: err.info||'Request Error',
                            dangerouslyUseHTMLString: true,
                            message: "<div>"+errData.map(item=>`<p class="font12px">${item.errorMsg}；</p>`).join('')+"</div>",
                            duration: 0
                        });
                    }else{
                        this.$message.error(err.info||'Request Error');
                    }
                });
            },
            changeAutoSend(row,val){
                console.log('changeTaskStatus',row,val);
                row.autoSendLoading = true;
                API.changeTaskAutoSend({
                    task_id:row.task_id,
                    auto_send:val,
                }).then(res=>{
                    row.autoSendLoading = false;
                    row.auto_send = val;
                    this.$message.success(res.info||'Operation successful');
                },err=>{
                    row.autoSendLoading = false;

                    let errData = err.data||[];
                    if(err.code==0&&errData.length>0){
                        this.$notify.error({
                            title: err.info||'Request Error',
                            dangerouslyUseHTMLString: true,
                            message: "<div>"+errData.map(item=>`<p class="font12px">${item.errorMsg}；</p>`).join('')+"</div>",
                            duration: 0
                        });
                    }else{
                        this.$message.error(err.info||'Request Error');
                    }
                });
            },
            toDetailPage(row){
                console.log('toDetailPage',row);
                this.actionRow = {...row};
                this.curShowPage = 'detail';
                this.$nextTick(()=>{
                    this.$refs.detailPage.init();
                });
            },
            editTask(data){
                this.actionType = 'edit';
                this.actionRow = {...data};
                this.curShowPage = 'create';
                this.$nextTick(()=>{
                    this.$refs.createPage.setData();
                });
            },
            startRefresh(){
                if(this.refreshTimer) return;
                this.refreshTimer = setInterval(()=>{

                    // 生成中 last_generate_status.inProgress>0    发送中 last_send_status==2
                    let dataList = this.dataList.filter(item=>{
                        let sendStatus = item.last_send_status;
                        let generateStatus = (item.last_generate_status||{}).inProgress||0;
                        return sendStatus=='2'||generateStatus > 0?item:null;
                    });
                    if(dataList.length>0) {
                        let IdsArr = dataList.map(item=>item.last_task_record_id);
                        API.getTaskSendStatus({
                            task_record_ids:IdsArr.join(',')
                        }).then(res=>{
                            let resData = res.data ||[];
                            resData.forEach(item=>{
                                let taskItem = this.dataList.find(task=>task.last_task_record_id === item.task_record_id );
                                if(taskItem){
                                    taskItem.last_send_time = item.send_time || taskItem.last_send_time;
                                    taskItem.last_send_status = item.send_status || taskItem.last_send_status;
                                    taskItem.last_generate_status = item.generate_status || taskItem.last_generate_status;
                                    taskItem.send_error_info = item.send_error_info || taskItem.send_error_info;
                                    taskItem.total_time = item.total_time ||  taskItem.total_time;
                                }
                            })
                        })
                    }
                },10*1000)
            },
            stopRefresh(){
                clearInterval(this.refreshTimer);
                this.refreshTimer = null;
            },
            secondToDuration(val){
                return utils.secondToDuration(val,'en');
            },
            isEvent(obj){
                return typeof obj === 'object' && obj !== null && 'target' in obj; // Event对象必须有target属性
            },
        },
        beforeDestroy() {
            this.stopRefresh();
        },
    }
</script>

<style lang="scss" scoped>

    .filter-bar{
        background-color: #f8f8f9;
        padding: 12px 20px 0;
        border-radius: 5px;
        ::v-deep .el-form-item{
            margin-bottom: 12px;
        }
    }

    .text-success{
        color: #619f53;
    }

    .mini-switch{
        transform: scale(0.8);
    }

    .topBtn{
        margin-left: 0;
        &.disabled{
            cursor: not-allowed!important;
            opacity: 0.6;
        }
    }
    .font12px{
        font-size: 12px;
    }

</style>
